module.exports = __webpack_public_path__ + "./images/Bildergalerie_Schriftzug_badische_Farben.jpg";